<template>
    <div >
        <Breadtabsheader/>
        <div class="h-content">
            <!-- 搜素条件 -->
            <div class="h-piece">
                <el-form :inline="true" :model="q" class="demo-form-inline h-formBorder">
                    <div class="h-thirdColumn w-newColumn">
                      <el-form-item label="物料编码">
                          <el-input v-model="q.materialCode" :clearable="true"></el-input>
                      </el-form-item>
                      <el-form-item label="物料描述">
                        <el-input v-model="q.materialName" :clearable="true"></el-input>
                      </el-form-item>
                      <el-form-item label="预测单号">
                          <el-input v-model="q.reformId" :clearable="true"></el-input>
                      </el-form-item>
                        <el-form-item label="下达日期">
                        <el-date-picker
                                placeholder="请选择下达日期"
                                v-model="q.sapTime"
                                clearable
                                type="date"
                                value-format="yyyy-MM-dd"
                                >
                        </el-date-picker>
                        </el-form-item>
                    </div>
                    <el-collapse-transition>
                        <div v-show="isScreen">
                            <div class="h-thirdColumn w-newColumn">
                                <el-form-item label="状态" prop="status">
                                  <el-select v-model="q.status" placeholder="请选择" :clearable="true">
                                    <el-option label="暂存" value="0"></el-option>
                                    <el-option label="已提交" value="1"></el-option>
                                    <el-option label="提交失败" value="2"></el-option>
                                  </el-select>
                                </el-form-item>
                                <el-form-item label="订单类型" prop="orderType">
                                  <brselect category="gaizhi_order_type" :v="q.orderType"
                                            v-model="q.orderType"  clearable></brselect>
                                </el-form-item>
                                <el-form-item label="生产版本" prop="edition">
                                  <brselect category="gaizhi_edition" :v="q.edition"
                                            v-model="q.edition" clearable></brselect>
                                </el-form-item>
                                <el-form-item label="库存地点" prop="lgort">
                                  <brselect category="gaizhi_lgort_kucun" :v="q.lgort"
                                            v-model="q.lgort" clearable></brselect>
                                </el-form-item>
                            </div>
                            <div class="h-thirdColumn w-newColumn">
                                <el-form-item label="改制类型">
                                    <el-select v-model="q.reformType"
                                               placeholder="请选择"
                                               clearable>
                                        <el-option label="生产改制" value="0"></el-option>
                                        <el-option label="库存改制" value="1"></el-option>
                                    </el-select>
                                </el-form-item>
                                <el-form-item label="工厂">
                                    <brselect category="gaizhi_lgort" :v="q.factory"
                                              v-model="q.factory" :multiple="true" clearable></brselect>
                                </el-form-item>
                                <el-form-item label="类型">
                                    <el-select v-model="q.reformTypePro"
                                               placeholder="请选择"
                                               clearable>
                                        <el-option label="内销改制" value="0"></el-option>
                                        <el-option label="外销改制" value="1"></el-option>
                                        <el-option label="研发样机" value="2"></el-option>
                                    </el-select>
                                </el-form-item>
                            </div>
                        </div>
                    </el-collapse-transition>
                </el-form>
                <div class="l-screenBox">
                    <div class="l-screen" @click="collapseChange">
                        <img :src="isScreen?closeScreen:drawScreen" alt="">
                        <div class="l-screenText">{{ isScreen ? "收起" : "展开" }}</div>
                    </div>
                    <div class="l-retrieval">
                        <el-button class="h-btn h-formBtn" @click="handleFilter">检索</el-button>
                        <el-button class="h-btn h-formBtn h-bgwhite" @click="resetData">重置
                        </el-button>
                    </div>
                </div>
            </div>

            <div class="h-table h-mrt30">
                <el-table
                        ref="ddtable"
                        :data="tableData"
                        @selection-change="handleSelectionChange"
                        stripe
                        border
                        style="width: 100%"
                        :span-method="objectSpanMethod"
                >

                    <el-table-column
                            type="selection"
                            fixed
                            width="40">
                    </el-table-column>
                    <el-table-column
                            type="index"
                            width="40"
                            label="序号"
                            fixed >
                    </el-table-column>
<!--                    <el-table-column
                            prop="agentCode"
                            label="经销商编码"
                            width="110">
                    </el-table-column>
                    <el-table-column
                            prop="agentName"
                            label="经销商名称"
                            :show-overflow-tooltip="true"
                            width="150">
                    </el-table-column>-->
                    <el-table-column
                            prop="materialCode"
                            label="物料编码"
                            width="110">
                    </el-table-column>
                    <el-table-column
                            prop="materialName"
                            label="物料名称"
                            width="150">
                    </el-table-column>
                    <el-table-column
                        prop="orderType"
                        label="订单类型"
                        width="110">
                      <template slot-scope="scope">
                        <brselect category="gaizhi_order_type" v-if="scope.row.reformTypePro == 0 || scope.row.reformTypePro == '' || scope.row.reformTypePro == null" :v="scope.row.orderType" v-model="scope.row.orderType"/>
                          <brselect category="gaizhi_order_type_pro"  v-if="scope.row.reformTypePro == 2" :v="scope.row.orderType" v-model="scope.row.orderType"/>
                      </template>
                    </el-table-column>
                    <el-table-column
                        prop="factory"
                        label="工厂"
                        width="110">
                      <template slot-scope="scope">
                        <brselect category="gaizhi_lgort" :v="scope.row.factory" v-model="scope.row.factory"/>
                      </template>
                    </el-table-column>
<!--                    <el-table-column
                            prop="lianqunName"
                            label="链群名称"
                            width="110">
                    </el-table-column>-->
                    <el-table-column
                            prop="number"
                            label="数量"
                            width="110">
                    </el-table-column>
                    <el-table-column
                            prop="reformType"
                            label="改制类型"
                            width="110">
                        <template scope="scope">
                            <span v-if="scope.row.reformType == '0'">生产改制</span>
                            <span v-if="scope.row.reformType == '1'">库存改制</span>
                        </template>
                    </el-table-column>
                    <el-table-column
                            prop="reformTypePro"
                            label="类型"
                            width="110">
                        <template scope="scope">
                            <span v-if="scope.row.reformTypePro == '0'">内销改制</span>
                            <span v-if="scope.row.reformTypePro == '1'">外销改制</span>
                            <span v-if="scope.row.reformTypePro == '2'">研发样机</span>
                            <span v-if="scope.row.reformTypePro == '3'">返修</span>
                        </template>
                    </el-table-column>
                    <el-table-column
                            prop="produceTime"
                            label="开始日期"
                            width="160">
                      <template slot-scope="scope">
                        <el-date-picker
                            :clearable="true"
                            v-model="scope.row.produceTime"
                            type="date"
                            value-format="yyyy-MM-dd"
                            placeholder="--日期--"
                            style="width:100%">
                        </el-date-picker>
                      </template>
                    </el-table-column>
                    <el-table-column
                        prop="edition"
                        label="生产版本"
                        width="110">
                      <template slot-scope="scope" v-if="scope.row.reformTypePro == 0 || scope.row.reformTypePro == '' || scope.row.reformTypePro == null">
                        <brselect category="gaizhi_edition" :v="scope.row.edition" v-model="scope.row.edition"/>
                      </template>
                        <template slot-scope="scope" v-if="scope.row.reformTypePro == 2">
                            <el-select filterable v-model="scope.row.edition" clearable placeholder="请选择"
                            >
                                <el-option
                                        v-for="(item,index) in scope.row.editionList"
                                        :key="item"
                                        :label="item"
                                        :value="item">
                                </el-option>
                            </el-select>
                        </template>
                    </el-table-column>
                    <el-table-column
                        prop="reformId"
                        label="预测单号"
                        :show-overflow-tooltip="true"
                        width="230">
                    </el-table-column>
                    <el-table-column
                        prop="areaName"
                        label="区域名称"
                        width="110">
                    </el-table-column>
                    <el-table-column
                            prop="plnnrId"
                            label="立项号"
                            width="110">
                    </el-table-column>
                    <el-table-column
                            prop="costCenter"
                            label="成本中心"
                            width="110">
                    </el-table-column>
                    <el-table-column
                        prop="lgort"
                        label="库存地点"
                        width="110">
                        <template slot-scope="scope">
                            <brselect category="gaizhi_lgort_kucun" :v="scope.row.lgort"
                                      v-model="scope.row.lgort"></brselect>
                        </template>
                    </el-table-column>

                    <el-table-column
                            prop="other1"
                            label="预算金额"
                            width="110">
                        <template slot-scope="scope">
                                <el-input  v-model="scope.row.other1"  :v="scope.row.other1" onkeyup="value=value.match(/\d+\.?\d{0,8}/)"></el-input>
                        </template>
                    </el-table-column>

                    <el-table-column
                        label="状态"
                        prop="status"
                        width="110">
                      <template slot-scope="scope">
                        <span v-if="scope.row.status == 0">暂存</span>
                        <span v-if="scope.row.status == 1">已提交</span>
                        <span v-if="scope.row.status == 2">提交失败</span>
                      </template>
                    </el-table-column>
                    <el-table-column
                            prop="sapMsg"
                            label="sap返回信息"
                            :show-overflow-tooltip="true"
                            width="150">
                    </el-table-column>
                    <el-table-column
                            prop="sapTime"
                            label="下达日期"
                            :show-overflow-tooltip="true"
                            width="110">
                    </el-table-column>
                    <el-table-column
                            fixed="right"
                            label="操作"
                            width="200" >
                        <template slot-scope="scope">
                                <el-button
                                        size="small" class="h-tableLink h-btn"
                                        @click="detail(scope.row)">查看
                                </el-button>
                                <el-button
                                        size="small" class="h-tableLink h-btn" v-if="cancelFlag"
                                        @click="detailSap(scope.row)">传参物料
                                </el-button>
                                <el-button
                                        size="small" class="h-tableLink h-btn" v-if="cancelFlag"
                                        @click="detailSapLog(scope.row)">sap传参
                                </el-button>
                        </template>
                    </el-table-column>
                </el-table>
                <div class="h-tableB h-mrt30">
                    <div class="h-tableBL">
                        <el-button class="h-btn h-formBtn h-bgblueQ" icon="h-el-icon h-el-icon-import"
                                   @click="exportExcel">批量导出
                        </el-button>
                        <el-button class="h-btn h-formBtn h-bgblueQ" icon="h-el-icon h-el-icon-import"
                                   @click="updateList">保存
                        </el-button>
                        <el-button class="h-btn h-formBtn h-bgblueQ" icon="h-el-icon h-el-icon-import"
                                   @click="submit">提交到sap
                        </el-button>
                    </div>
                    <div class="h-pagination2">
                        <pagination :page="q" @query="query" />
                    </div>
                </div>
                <el-dialog
                        title=""
                        :visible.sync="detailFlag"
                        :fullscreen="false"
                        width="70%"
                        :modal="true"
                        :before-close="handleClose"
                        class="h-dialog2"
                >
                    <h3>&nbsp;</h3>
                    <div class="tanBox">
                        <el-table
                                :data="tableDataDetail"
                                border
                                max-height="420"
                                style="width: 94%; margin: 0 auto"
                        >
                            <el-table-column label="序号" type="index" fixed width="50">
                            </el-table-column>
                            <el-table-column
                                    prop="projectId"
                                    label="项目"
                                    style="width: 10%;">
                            </el-table-column>
                            <el-table-column
                                    prop="materialCodeC"
                                    label="组件"
                                    style="width: 15%;">
                            </el-table-column>
                            <el-table-column
                                    prop="materialNameC"
                                    label="描述"
                                    style="width: 20%;">
                            </el-table-column>
                            <el-table-column
                                    prop="numberC"
                                    label="数量"
                                    style="width: 15%;">
                            </el-table-column>
                            <el-table-column
                                    prop="unit"
                                    label="单位"
                                    style="width: 15%;">
                            </el-table-column>
                            <el-table-column
                                    prop="lgortc"
                                    label="项目库存地点"
                                    style="width: 15%;"
                                   >
                            </el-table-column>
                            <el-table-column
                                    prop="remark"
                                    label="备注"
                                    style="width: 15%;"
                                    >
                            </el-table-column>
                        </el-table>
                        <div class="h-tableB h-mrt30">
                            <div class="h-tableBL">
                                <el-button type="primary" @click="exportExcelToSap()">批量导出</el-button>
                            </div>
                        </div>
                    </div>
   <!--                 <div
                            style="
          display: flex;
          justify-content: flex-end;
          align-items: center;
          margin-top: 20px;
        "
                    >
                        <paginationmin :page="diff" @query="handleMessage3" />
                    </div>-->
                </el-dialog>

                <el-dialog
                        title=""
                        :visible.sync="detailFlagToSap"
                        :fullscreen="false"
                        width="70%"
                        :modal="true"
                        :before-close="handleClose"
                        class="h-dialog2"
                >
                    <h3>&nbsp;</h3>
                    <div class="tanBox">
                        <el-table
                                :data="tableDataDetailToSap"
                                border
                                max-height="420"
                                style="width: 94%; margin: 0 auto"
                        >
                            <el-table-column label="序号" type="index" fixed width="50">
                            </el-table-column>
                            <el-table-column
                                    prop="projectId"
                                    label="项目"
                                    style="width: 10%;">
                            </el-table-column>
                            <el-table-column
                                    prop="materialCode"
                                    label="组件"
                                    style="width: 15%;">
                            </el-table-column>
                            <el-table-column
                                    prop="materialName"
                                    label="描述"
                                    style="width: 20%;">
                            </el-table-column>
                            <el-table-column
                                    prop="number"
                                    label="数量"
                                    style="width: 15%;">
                            </el-table-column>
                            <el-table-column
                                    prop="unit"
                                    label="单位"
                                    style="width: 15%;">
                            </el-table-column>
                            <el-table-column
                                    prop="lgort"
                                    label="项目库存地点"
                                    style="width: 15%;"
                            >
                            </el-table-column>
                            <el-table-column
                                    prop="remark"
                                    label="备注"
                                    style="width: 15%;"
                            >
                            </el-table-column>
                        </el-table>
                        <div class="h-tableB h-mrt30">
                            <div class="h-tableBL">
                                <el-button type="primary" @click="exportExcelToSap()">批量导出</el-button>
                            </div>
                        </div>
                    </div>
                    <!--                 <div
                                             style="
                           display: flex;
                           justify-content: flex-end;
                           align-items: center;
                           margin-top: 20px;
                         "
                                     >
                                         <paginationmin :page="diff" @query="handleMessage3" />
                                     </div>-->
                </el-dialog>

                <el-dialog
                        title="SAP推送日志详情"
                        :visible.sync="detailFlagToSapLog"
                        width="70%"
                        :before-close="handleCloseLog"
                >
                    <div class="tanBox">
                        <pre style="white-space: pre-wrap;line-height:1.6;font-size:14px;">{{tosapLog}}</pre>
                    </div>
                    <span slot="footer">
        <el-button @click="handleCloseLog">关闭</el-button>
    </span>
                </el-dialog>
            </div>
        </div>
    </div>
</template>
<script>

    import reformService from "../../../api/reform/reformService.js";
    import updownfile from "../../../utils/updownfile";
    import ss from "../../../api/SystemService";
    import engTable from "../../../api/dingd/ProductEngTable";
    export default {
        components: {},
        data() {
            return {
                //查询属性
                q: {
                    agentCode:null,
                    agentName:null,
                    materialCode:null,
                    materialName:null,
                    reformId:null,
                    status:null,
                    lianqun:null,
                    reformType:null,
                    reformTypePro:null,
                    materialStation:null,
                    cdatebegin:null,
                    cdateend:null,
                    spbegin:null,
                    spend:null,
                    id:null,
                    edition:null,
                    sapTime:null,
                    delflag:1,
                    pageSize:10,
                    pageNo:1,
                    total:0,
                },
                qdetail: {
                    id:null,
                    agentCode:null,
                    agentName:null,
                    materialCode:null,
                    materialName:null,
                    reformId:null,
                    status:null,
                    lianqun:null,
                    reformType:null,
                    reformTypePro:null,
                    materialStation:null,
                    cdatebegin:null,
                    cdateend:null,
                    spbegin:null,
                    spend:null,
                    id:null,
                    edition:null,
                    sapTime:null,
                    delflag:1,
                },
                //表单
                f:{
                    agentCode:null, // 经销商编码
                    agentName:null, // 经销商名称
                    areaCode:null, // 区域编码
                    areaName:null, // 区域名称
                    lianqun:null, // 链群`
                    lianqunName:null, // 链群名称
                    materialCode:null, // 物料编码
                    materialName:null, // 物料名称
                    number:null, // 数量
                    specificIds:null, // 改制大id
                    specificDivisions:null,//改制大类
                    specificReqs:null, // 改制大描述
                    oneLId:null, // 产品大类编码
                    oneLName:null, // 产品大类名称
                    reformPrice:null, // 定制加价（单台）
                    currency:null, // 币种
                    reformId:null, // 定制编号
                    reformType:null, // 0生产改制1库存改制
                    marketForecastId:null, // 市场预测单号
                    produceTime:null, // 生产日期
                    isUsed:null, // 1：已使用，0：没使用
                    remark:null, // 备注
                    instid:null, // 流程id
                    cucode:null, // 创建人编码
                    cuname:null, // 创建人名称
                    lucode:null, // 修改人编码
                    ldate:null, // 最后修改时间
                    cdate:null,//创建日期
                    lastSptgTime:null,//审核通过时间

                    plnnrId:null, // 立项号
                    costCenter:null, // 成本中心

                },
                dexcel:{
                    agentCode:null,
                    agentName:null,
                    materialCode:null,
                    materialName:null,
                    reformId:null,
                    status:null,
                    lianqun:null,
                    reformType:null,
                    reformTypePro:null,
                    materialStation:null,
                    cdatebegin:null,
                    cdateend:null,
                    spbegin:null,
                    spend:null,
                    id:null,
                    edition:null,
                    sapTime:null,
                },
                tableSelectedList:[],
                //table列表
                tableData: [],
                tableDataDetail:[],
                tableDataDetailToSap:[],
                tosapLog:null,
                showhistory: null,
                // 展开折叠筛选
                isScreen: false,
                detailFlag:false,
                detailFlagToSap:false,
                detailFlagToSapLog:false,
                tosapid:null,
                closeScreen: require("@/assets/images/pimg/closeallic.png"),
                drawScreen: require("@/assets/images/pimg/dobleArr.png"),
                chehuidialogFormVisible:false,
                zuofeidialogFormVisible:false,

                cancelFlag:false,
                zf:{
                    id:null,//主键id
                    deleteReason:null,//删除原因
                },
            }
        },
        created() {
            this.query();
            if (this.$store.getters.hasRole('swyl_admin') || this.$store.getters.hasRole('swyl_shengchan')) {
                this.cancelFlag = true;
            }
        },
        methods: {
            query() {
                reformService.selecSapPage(this.q).then(rd=>{
                    this.q.total = rd.total;
                    this.tableData = rd.records;
                    this.getRowSpan();
                })
            },
            handleFilter() {
                this.query();
            },

            handleSelectionChange(lists){
                this.tableSelectedList = lists;
            },
            resetData(){
                var pageSize=this.q.pageSize;
                var pageNo=this.q.pageNo;
                var total=this.q.total;
                this.q= {
                    agentName:null,
                    agentCode:null,
                    id:null,
                    materialCode:null,
                    materialName:null,
                    pageSize: pageSize,
                    pageNo: pageNo,
                    total:total,
                }
            },
            //查看按钮功能
            toSee(q) {
                this.$router.push({path: '/chanp/seeReform',query: {ywid: q.id}});
            },

            //导出明细
            printDetail(x) {
                reformService.checkDownload(x).then(rd => {
                    if(rd.f){
                        updownfile.down('/api/swyl/v1/reform/reformMain/downloadExcelDetail',{id:x},"get");
                    }
                })
            },
            //删除
            doDelete(row){
                this.$msg.confirm("确认删除?", () => {
                    reformService.deleteById(row.id).then(rd => {
                        this.$msg.msgs(rd.msg);
                        this.query();
                    });
                });

            },

            // 展开折叠
            collapseChange() {
                this.isScreen = !this.isScreen;
            },
            formatDate(row, column) {
                // 获取单元格数据
                let data = row[column.property]
                if(data == null || data == '') {
                    return null
                }
                let dt = new Date(data)
                return this.$util.riQi3(dt);
            },
            exportExcel(){
                updownfile.down("api/swyl/v1/reform/reformMainSap/downloadExcel", this.q, "post");
            },
            //明细导出
            exportExcelToSap() {
                this.dexcel.id = this.tosapid;
                updownfile.down("api/swyl/v1/reform/reformMainSap/sapDetailSapExcel",this.dexcel,"get");
            },

            reformCh(v){
                this.zf.id = v.id;
                this.chehuidialogFormVisible = true;
            },
            reformZf(v){
                this.zf.id = v.id;
                this.zuofeidialogFormVisible = true;
            },
            cancel(){
                this.chehuidialogFormVisible = false;
                this.zuofeidialogFormVisible = false;
                this.zf = {
                    id:null,
                    deleteReason:null,
                };
            },
            updateList(){
              reformService.updateSapReform({"list":this.tableData}).then(rd => {
                this.$msg.msgs("调整保存成功");
                this.query();
              })
            },
            getRowSpan() {
              this.rowSpanArr = [];
              this.tableData.forEach((item, index) => {
                if (index == 0) {
                  this.rowSpanArr.push(1);
                  this.position = 0;
                } else {
                  if (this.tableData[index].id== this.tableData[index - 1].id) {
                    this.rowSpanArr[this.position] += 1; //项目名称相同，合并到同一个数组中
                    this.rowSpanArr.push(0);
                    this.tableData[index].id= this.tableData[index - 1].id;
                  } else {
                    this.rowSpanArr.push(1);
                    this.position = index;
                  }
                }
              });
            },
          objectSpanMethod({ row,column, rowIndex,columnIndex }) {
            // 只合并区域位置
            if (columnIndex === 0) {
              const _row = this.rowSpanArr[rowIndex];
              return {
                rowspan: _row, //行
                colspan: 1 //列
              };
            }
            if(columnIndex === 1){
              const _row = this.rowSpanArr[rowIndex];
              const _col = _row>0 ? 1 : 0;
              return {
                rowspan: _row,
                colspan: _col
              }
            }
            //分条显示数据
            if(
                columnIndex === 2 || columnIndex === 4 ||columnIndex === 3 ||columnIndex === 5
                ||columnIndex === 6 || columnIndex === 7 || columnIndex === 8 ||columnIndex === 9
                ||columnIndex === 10 ||columnIndex === 11 ||columnIndex === 12 ||columnIndex === 13 ||columnIndex === 15 ||columnIndex === 14
            ){
              const _row = this.rowSpanArr[rowIndex];
              const _col = _row>0 ? 1 : 0;
              return {
                rowspan: _row,
                colspan: _col
              }
            }
          },
          //提交到sap
          submit(){
            if(this.tableSelectedList.length==0){
              this.$message.error("请选择需要提交的数据");
              return;
            }
            let query = [];
            for(var i=0;i<this.tableSelectedList.length;i++){
              let querys = {};
              querys.id = this.tableSelectedList[i].id;
              querys.materialCode = this.tableSelectedList[i].materialCode;
              querys.reformId = this.tableSelectedList[i].reformId;
              query.push(querys);
            }
            console.log(query);
            reformService.toSapReform(query).then(rd => {
              if(rd.f){
                  for (let i = 0; i < rd.obj.length; i++) {
                      if(rd.obj[i].sapFlag == 'E'){
                          setTimeout(() => {
                              this.$message.error("产品:"+rd.obj[i].materialCode+"报错信息:"+rd.obj[i].sapMsg);
                          }, 10);
                      }
                      if(rd.obj[i].sapFlag == 'S'){
                          setTimeout(() => {
                              this.$message({
                                  message: "产品:"+rd.obj[i].materialCode+"提交成功:"+rd.obj[i].sapMsg,
                                  type: 'success'
                              });
                          }, 10);
                      }
                  }
                this.query();
              }
            })
          },
            detail(v){
                this.detailFlag = true;
                this.qdetail.id = v.id
                reformService.selecSapDetailPage(this.qdetail).then(rd=>{
                    this.tableDataDetail = rd.msg;
                })
            },
            detailSap(v){
                this.detailFlagToSap = true;
                this.qdetail.id = v.id;
                this.tosapid = v.id;
                reformService.selecSapDetailSap(this.qdetail).then(rd=>{
                    this.tableDataDetailToSap = rd.msg;
                })
            },
            handleClose(){
                this.tableDataDetail =[];
                this.detailFlag = false;
                this.tableDataDetail =[];
                this.detailFlagToSap = false;
            },

            handleCloseLog(){
                this.tosapLog = "";
                this.detailFlagToSapLog = false;
            },

            detailSapLog(v){
                this.detailFlagToSapLog = true;
                this.qdetail.id = v.id;
                this.tosapid = v.id;
                reformService.getReformToSapLog(this.qdetail).then(rd=>{
                    console.log(rd.obj);

                    this.tosapLog = rd.obj;
                })
            },

        }
    }
</script>
